import { render, staticRenderFns } from "./EBITDAVergleich.vue?vue&type=template&id=232307ce&"
import script from "./EBITDAVergleich.vue?vue&type=script&lang=ts&"
export * from "./EBITDAVergleich.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports